export type VasErrorBody = {
  status: string;
  code: string;
  title: string;
  detail: string;
};

export type VasErrorResponse = {
  errors: VasErrorBody[];
};

export class NewVasError extends Error {
  public readonly errorBody: VasErrorResponse;

  constructor(body: VasErrorResponse, message: string) {
    super(message);
    this.errorBody = body;
  }
}
